import { APP, AppAction } from './actions';

interface AppState {
  init: boolean;
}

export const INITIAL_STATE: AppState = {
  init: false,
};

const appReducer = (state = INITIAL_STATE, action: AppAction): AppState => {
  switch (action.type) {
    case APP.INIT:
      return {
        ...state,
        init: true,
      };
    default:
      return state;
  }
};

export { appReducer };
